import { React, useState, useContext, useEffect } from "react";
import { initializeFirebase, requestNotificationPermission } from "../firebase"; // Adjust path
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../includes/footer-tab"; // Adjust path
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa"; // Action button icons
import { MdOutlineAddCard } from "react-icons/md"; // Action button icon
import { BiMoneyWithdraw, BiTimeFive } from "react-icons/bi"; // Action button icon, Time icon
import { FaChartLine, FaPlay } from "react-icons/fa"; // Market card icons
import { AuthContext } from "../context/AuthContext"; // Adjust path
import { ToastContainer, toast } from "react-toastify";
import Preloader from "./Preloader"; // Adjust path
import { GrMenu } from "react-icons/gr"; // Header icon
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
// import { onMessage } from 'firebase/messaging'; // Removed if not used
import styles from '../assets/css/Dashboard.module.css'; // Import CSS Module

function Dashboard() {
  const [preloader, setPreloader] = useState(true);
  const [MarketData, setMarketData] = useState([]);
  const [UpcommingMarketData, setUpcommingMarketData] = useState([]);
  const [Walletd, setWalletd] = useState(0); // Wallet not shown in this header design
  const [banner, setBanner] = useState([]);

  const {
    app_name = "AGHORI MATKA",
    getMarkets,
    isAuthenticated,
    profile,
    WhatsappMessageSupport,
    TelegramLink, // Optional Telegram Link
    base_url,
    FSC_KEY_UPDATE,
    YoutubeChannel
  } = useContext(AuthContext);

  const navigate = useNavigate();

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  // Toast message function
  const message = (status, text) => {
    const options = {
        position: "top-right", autoClose: 3000, hideProgressBar: false,
        closeOnClick: true, pauseOnHover: true, draggable: true,
        progress: undefined, theme: "dark",
    };
    if (status === 1) toast.success(text, options);
    else if (status === 0) toast.error(text, options);
    else if (status === 2) toast.warning(text, options);
  };

  // --- Firebase Initialization & Notification Permission ---
  useEffect(() => {
    initializeFirebase();
    requestNotificationPermission()
      .then((token) => {
        if (token && FSC_KEY_UPDATE) {
          FSC_KEY_UPDATE(token, (d) => { console.log("FCM Token Update Response:", d); });
        }
      })
      .catch((error) => { console.error("Error getting FCM token:", error); });
  }, [FSC_KEY_UPDATE]);


  // --- Fetch Market and Profile Data ---
  useEffect(() => {
    let isMounted = true;
    setPreloader(true);

    const fetchData = async () => {
        try {
            // Fetch Markets
            if (getMarkets) {
                await new Promise((resolve, reject) => {
                    getMarkets((response, boolRes) => {
                        if (!isMounted) return reject('Component unmounted');
                        if (!boolRes && response.response?.status !== 200) {
                            message(0, response.response?.data?.error || "Failed to fetch markets");
                            reject('Market fetch error');
                        } else if (response.status === 0) {
                            message(0, response.msg);
                            reject('Market API error');
                        } else {
                            setMarketData(response.running_game || []);
                            const sortedData = (response.upcomming_game || [])
                                .sort((a, b) => {
                                    if (a.sequence !== b.sequence) return a.sequence - b.sequence;
                                    const dateA = new Date(a.datetime);
                                    const dateB = new Date(b.datetime);
                                    return dateA - dateB;
                                });
                            setUpcommingMarketData(sortedData);
                            setBanner(response.banner || []);
                            resolve();
                        }
                    });
                });
            }

            // Fetch Profile (keep if needed for auth check elsewhere)
            if (profile) {
                await new Promise((resolve, reject) => {
                    profile((response) => {
                        if (!isMounted) return reject('Component unmounted');
                        if (response.status === 0) {
                            reject('Profile API error');
                        } else {
                          setWalletd("₹ "+response.data[0].wallet);
                            resolve();
                        }
                    });
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            if (isMounted) {
                setPreloader(false);
            }
        }
    };

    if (isAuthenticated) { fetchData(); }
    else { setPreloader(false); }

    return () => { isMounted = false; };

  }, [getMarkets, profile, isAuthenticated]);


  // --- Framer Motion Variants ---
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.05 } },
  };
  const itemVariants = {
    hidden: { y: 10, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: 'tween', duration: 0.3 } },
  };


  return (
    // Use the container style from the previous CSS
    <div className={styles.aghoriContainer}>
      <Preloader status={preloader} />
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />

      {/* Main content area */}
      {!preloader && (
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          exit={{ opacity: 0 }}
        >
          {/* --- Header (Keep previous Aghori Style) --- */}
          <motion.div className={styles.aghoriHeader} variants={itemVariants}>
            <button onClick={() => navigate("/mine")} className={styles.aghoriHeaderMenuBtn} aria-label="Menu">
              <GrMenu />
            </button>
            <h1 className={styles.aghoriHeaderTitle}>{app_name}</h1>
            <div className={styles.headerPlaceholder}>{Walletd}</div>
          </motion.div>

          {/* --- Banner Carousel (Keep previous Aghori Style) --- */}
           {banner.length > 0 && (
             <motion.div className={styles.aghoriCarouselContainer} variants={itemVariants}>
               <Carousel
                 showThumbs={false} showStatus={false} infiniteLoop={true}
                 showArrows={false} autoPlay={true} interval={3000} stopOnHover={true}
                 swipeable={true} emulateTouch={true}
               >
                 {banner.map((item, index) => (
                   <div key={index}>
                     <img src={`${base_url}${item.banner_img}`} alt={`Offer ${index + 1}`} className={styles.aghoriCarouselImage}/>
                   </div>
                 ))}
               </Carousel>
             </motion.div>
           )}

          {/* --- Action Buttons (Keep previous Aghori Style) --- */}
          <motion.div className={styles.aghoriActionButtons} variants={itemVariants}>
             {/* WhatsApp Button */}
             <button onClick={() => { if(WhatsappMessageSupport) window.open(WhatsappMessageSupport, '_blank'); }} className={`${styles.aghoriActionButton} ${styles.aghoriWhatsapp}`}>
               <FaWhatsapp />
             </button>
             {/* Add Fund Button */}
             <button onClick={() => navigate('/recharge')} className={`${styles.aghoriActionButton} ${styles.aghoriAddFund}`}>
               <span className={styles.aghoriAddFundIcon}>₹</span> {/* Using + icon */}
               फंड जोड़ें
             </button>
             {/* Withdraw Button */}
             <button onClick={() => navigate('/withdrawal')} className={`${styles.aghoriActionButton} ${styles.aghoriWithdraw}`}>
               <BiMoneyWithdraw /> निकासी
             </button>
          </motion.div>

          {/* --- How to Play Button (Keep previous Aghori Style) --- */}
          <motion.div className={styles.aghoriHowToPlayContainer} variants={itemVariants}>
             <button className={styles.aghoriHowToPlayButton} onClick={() => { if(YoutubeChannel) window.location.href = YoutubeChannel; }}>
             कैसे खेले गेम
             </button>
          </motion.div>

          {/* --- Market List (NEW DESIGN) --- */}
          <motion.div className={styles.marketListNew} variants={itemVariants}>
             {/* Upcoming Markets */}
             {UpcommingMarketData.map((market) => (
                <div className={`${styles.marketCardNew}`} key={`upcoming-${market.game_id}`}>
                  <div className={styles.marketCardTopNew}>
                     <div className={styles.marketInfoNew}>
                        <h3 className={styles.marketNameNew}>{market.game_name.toUpperCase()}</h3>
                        <Link to={`/gamechart/${market.match_id || market.game_id}`} className={styles.marketChartLinkNew} aria-label={`Chart for ${market.game_name}`}>
                           <FaChartLine className={styles.chartIconNew}/>
                           <span className={styles.chartLabelNew}>खेल चार्ट</span>
                        </Link>
                     </div>
                     <div className={`${styles.marketActionNew} ${styles.marketActionNewMiddle}`}>
                      <p className={styles.marketResultNew}>{market.result || 'XX'}</p>
                      </div>
                     <div className={styles.marketActionNew}>
                         {market.active ? (
                           <Link to={`/play/${market.game_id}`} className={`${styles.playButtonNew} ${styles.playActiveNew}`} aria-label={`Play ${market.game_name}`}>
                             प्ले <FaPlay />
                           </Link>
                         ) : (
                           <span className={`${styles.playButtonNew} ${styles.playInactiveNew}`}>बंद</span> // Or TIME OUT
                         )}
                     </div>
                  </div>
                  <div className={styles.marketCardTimeBarNew}>
                      <span><BiTimeFive /> खुला: {market.start_time}</span>
                      {/* Conditionally show close time if different */}
                      {market.end_time && market.start_time !== market.end_time &&
                          <span>बंद: {market.end_time}</span>
                      }
                  </div>
                </div>
             ))}

             {/* Active/Regular Markets */}
             {MarketData.map((market) => (
                 <div className={styles.marketCardNew} key={`active-${market.game_id}`}>
                   <div className={styles.marketCardTopNew}>
                      <div className={styles.marketInfoNew}>
                         <h3 className={styles.marketNameNew}>{market.game_name.toUpperCase()}</h3>
                         <Link to={`/gamechart/${market.game_id}`} className={styles.marketChartLinkNew} aria-label={`Chart for ${market.game_name}`}>
                            <FaChartLine className={styles.chartIconNew}/>
                            <span className={styles.chartLabelNew}>खेल चार्ट</span>
                         </Link>
                      </div>
                      <div className={`${styles.marketActionNew} ${styles.marketActionNewMiddle}`}>
                      <p className={styles.marketResultNew}>{market.result || 'XX'}</p>
                      </div>
                      <div className={styles.marketActionNew}>
                          <Link to={`/play/${market.game_id}`} className={`${styles.playButtonNew} ${styles.playActiveNew}`} aria-label={`Play ${market.game_name}`}>
                          प्ले <FaPlay />
                          </Link>
                      </div>
                   </div>
                   <div className={styles.marketCardTimeBarNew}>
                       <span><BiTimeFive /> खुला: {market.start_time}</span>
                       {market.end_time && market.start_time !== market.end_time &&
                           <span>बंद: {market.end_time}</span>
                       }
                   </div>
                 </div>
             ))}
          </motion.div>

        </motion.div>
      )} {/* End !preloader condition */}

      {/* Footer Component */}
      <Footer /> {/* Ensure Footer uses the AghoriFooter.module.css styles */}
    </div>
  );
}

export default Dashboard;
